import React, { ReactNode } from "react";
import "./PerpetualAppCheck.scss";
import { useLicenseSelector } from "userful-chronos-common-store/dist/license";
import {
    isAppAllowedInPerpetualMode,
    isLicenseInPerpetualMode,
} from "userful-chronos-app-common-js/dist/models/license/license";
import { useTranslation } from "react-i18next";
import InitLoading from "../../Widgets/InitLoading/InitLoading";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

interface IProps {
    children: ReactNode;
}

export default function PerpetualAppCheck(props: IProps) {
    const license = useLicenseSelector((state) => state.licenseStore.license);
    const licenseReady = useLicenseSelector((state) => state.licenseStore.ready);
    const perpetualMode = isLicenseInPerpetualMode(license);
    const { t } = useTranslation();
    if (!licenseReady) {
        return <InitLoading />;
    }

    if (!perpetualMode) {
        return <>{props.children}</>;
    }
    const licensedAppID = getGlobalStates().licenseAppID || getGlobalStates().appID.value;
    const isAppAllow = isAppAllowedInPerpetualMode(licensedAppID, license);
    if (isAppAllow) {
        return <>{props.children}</>;
    }
    return <div className="perpetualModeAppContainer">{t("ConfigApp.LicenseDetails.perpetualModeDisabledApp")}</div>;
}
